var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.701 0 0 4.7 0 10.5 0 16.297 4.701 21 10.5 21S21 16.297 21 10.5C21 4.7 16.299 0 10.5 0zm3.938 6.029l1.845 1.845-7.096 7.096-4.47-4.47 1.846-1.846 2.625 2.625 5.25-5.25z",
    fill: "#FFCF31"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgLTAuMDAwNjEwMzUyQzQuNzAxMzcgLTAuMDAwNjEwMzUyIDAgNC43MDA3NiAwIDEwLjQ5OTRDMCAxNi4yOTggNC43MDEzNyAyMC45OTk0IDEwLjUgMjAuOTk5NEMxNi4yOTg2IDIwLjk5OTQgMjEgMTYuMjk4IDIxIDEwLjQ5OTRDMjEgNC43MDA3NiAxNi4yOTg2IC0wLjAwMDYxMDM1MiAxMC41IC0wLjAwMDYxMDM1MlpNMTQuNDM3NSA2LjAyOTAxTDE2LjI4MjkgNy44NzQzOUw5LjE4NzUgMTQuOTY5OEw0LjcxNzEyIDEwLjQ5OTRMNi41NjI1IDguNjU0MDFMOS4xODc1IDExLjI3OUwxNC40Mzc1IDYuMDI5MDFaIiBmaWxsPSIjRkZDRjMxIi8+Cjwvc3ZnPgo=";
export { SvgIconCheck as ReactComponent };